export default __webpack_public_path__ + "c6af9136e1635f6fb0a4879bbe2cd86f.svg";